/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, useEffect, useRef, useState } from 'react';
import checkMark from '../../assets/images/check-mark.svg';
import crossMark from '../../assets/images/model/red-cross.svg';
import omega from '../../assets/images/model/omega (italian).svg';
import italic from '../../assets/images/model/italic.svg';
import bold from '../../assets/images/model/bold.svg';
import underline from '../../assets/images/model/underline.svg';
import eraser from '../../assets/images/model/clear formatting.svg';
import omegaGray from '../../assets/images/model/omega-grey.svg';
import 'react-quill/dist/quill.snow.css';
import EditorInput from '../activity/EditorInput';
import OptionStudent from '../activity/OptionStudent';
import MediaComponent from '../activity/MediaComponent';
// import { activityInProgress } from "../../Store/api/activities";
const StudentAnswer = ({
  activity,
  answers,
  setAnswer,
  submittedActivities,
  percentage,
  editorValue,
  answerArrayNotEmpty,
  completedActivity,
  handleActivityProgress,
  setUpdateAnswers,
  setMaximizeImage,
  setImageVideoUrl,
  setStudentAnswers,
  studentAnswers,
  handleBlanks,
}) => {
  /* MCQS */
  // const questionTypes = {
  //   mcqs: "Multiple Choice",
  //   blanks: "Blanks",
  //   truefalse: "True & False",
  //   mix: "Mix type",
  //   matching: "Matching",
  //   fr: "Free response",
  // };

  const questionTypes = {
    mcqs: 'multiple choice',
    fr: 'long response',
    truefalse: 'true and false',
    matching: 'matching',
    blanks: 'fill in the blanks',
    sa: 'short response',
    or: 'order list',
  };

  useEffect(() => {
    // Check if there are no existing student answers
    if (!studentAnswers.length) {
      // Find the answer that has a type of "blanks" and contains studentSelectedBanks
      const blanksAnswer = activity?.activityAnswers?.[0]?.answers.find(
        (answer) => answer.type === 'blanks' && answer.studentSelectedBanks
      );

      // Set the student answers to the found answer's studentSelectedBanks if it exists
      if (blanksAnswer) {
        setStudentAnswers(blanksAnswer.studentSelectedBanks);
      }
    }
  }, [activity?._id]);

  return (
    <>
      {activity?.questions?.map((question, questionIndex) => (
        <MultipleChoiceQuestions
          question={question}
          questions={activity?.questions}
          questionIndex={questionIndex}
          setAnswer={setAnswer}
          questionTypes={questionTypes}
          answers={answers}
          submittedActivities={submittedActivities}
          activity={activity}
          key={questionIndex}
          percentage={percentage}
          studentAnswers={studentAnswers}
          setStudentAnswers={setStudentAnswers}
          editorValue={editorValue}
          answerArrayNotEmpty={answerArrayNotEmpty}
          completedActivity={completedActivity}
          handleActivityProgress={handleActivityProgress}
          setUpdateAnswers={setUpdateAnswers}
          setMaximizeImage={setMaximizeImage}
          setImageVideoUrl={setImageVideoUrl}
          handleBlanks={handleBlanks}
        />
      ))}
    </>
  );
};

function MultipleChoiceQuestions({
  question,
  questionIndex,
  setAnswer,
  questionTypes,
  answers,
  activity,
  editorValue,
  studentAnswers,
  percentage,
  questions,
  setStudentAnswers,
  completedActivity,
  setActivityInProgress,
  activityInProgress,
  handleActivityProgress,
  shouldFetchActivity,
  setUpdateAnswers,
  setMaximizeImage,
  setImageVideoUrl,
  handleBlanks,
}) {
  const [isExpanded, setIsExpanded] = useState(true);
  const [, setSelectedOptionIndex] = useState(null);
  const [answerModified, setAnswerModified] = useState(false);
  const [error, setError] = useState({});
  const [shuffledBlanksBank, setShuffledBlanksBank] = useState([]);
  const inputRefs = useRef([]); // To keep track of input elements
  const [showSpanishChars, setShowSpanishChars] = useState(false);
  const [focusedInputIndex, setFocusedInputIndex] = useState(null);

  // Function to adjust the width of input fields
  const adjustInputWidth = (index) => {
    if (inputRefs.current[index]) {
      const input = inputRefs.current[index];
      const span = document.createElement('span');
      span.style.visibility = 'hidden';
      span.style.whiteSpace = 'pre';
      span.style.font = window.getComputedStyle(input).font;
      span.textContent = input.value || input.placeholder; // Measure content including placeholder
      document.body.appendChild(span);
      const newWidth = span.offsetWidth + 28; // Add some padding
      document.body.removeChild(span);
      input.style.width = `${Math.max(newWidth, 65)}px`; // Ensure minimum width
    }
  };
  function checkTextVariations(text, questionBankQuestion) {
    const variations = [
      text,
      `${text}.`,
      `${text},`,
      `${text}'`,
      `${text}"`,
      `${text}?`,
      `${text}!`,
      `${text};`,
      `${text}:`,
      `${text}\n`,
      `${text}\t`,
      `${text}-`,
      `${text}_`,
      `${text}(`,
      `${text})`,
      `${text}[`,
      `${text}]`,
      `${text}<`,
      `${text}>`,
      `${text}/`,
      `${text}\\`,
      `${text}|`,
      `${text}@`,
      `${text}#`,
      `${text}$`,
      `${text}%`,
      `${text}^`,
      `${text}&`,
      `${text}*`,
      `${text}=`,
      `${text}+`,
      `${text}~`,
      `${text}` + String.fromCharCode(160),
    ];

    for (const variation of variations) {
      if (questionBankQuestion.includes(variation)) {
        return true;
      }
    }

    return false;
  }

  const toggleSpanishChars = () => {
    setShowSpanishChars((prev) => !prev);
  };
  // useEffect(() => {
  //   if (studentAnswers && studentAnswers.length > 0) {
  //     studentAnswers.forEach((item) => {
  //       if (
  //         answers &&
  //         answers[questionIndex] &&
  //         answers[questionIndex].answerArray
  //       ) {
  //         setAnswer(
  //           questionIndex,
  //           "answerArray",
  //           answers[questionIndex].answerArray.map((e, i) =>
  //             i === item.indexNo ? item.answers[0] : e
  //           )
  //         );
  //         setAnswer(
  //           questionIndex,
  //           "studentSelectedBlanks",
  //           studentAnswers.map((e) => ({
  //             indexNo: e.indexNo,
  //             answers: e.answers
  //           }))
  //         );

  //         // Adjust the input width for each item
  //         adjustInputWidth(item.indexNo);
  //       }
  //     });
  //   }
  // }, [studentAnswers]);
  useEffect(() => {
    for (let index = 0; index < studentAnswers.length; index++) {
      const element = studentAnswers[index];
      if (element.type === 'blanks') {
        for (let i = 0; i < element.studentSelectedBlanks.length; i++) {
          adjustInputWidth(element.studentSelectedBlanks[i].indexNo);
        }
      }
    }
  }, [studentAnswers]);

  // useEffect(() => {
  //   setStudentAnswers([]);
  // }, []);
  // Adjust width on input change
  const handleInputChange = (questionIndex, index, event) => {
    const newValue = event.target.value;

    // Update the answer array in local state
    setAnswer(
      questionIndex,
      'answerArray',
      answers[questionIndex].answerArray.map((e, i) => (i === index ? newValue : e))
    );

    // Update the current student answer based on the index
    const updatedAnswers = [...studentAnswers];
    const answerIndex = updatedAnswers.findIndex((item) => item.indexNo === index);

    if (answerIndex >= 0) {
      // Update existing answer
      updatedAnswers[answerIndex] = {
        ...updatedAnswers[answerIndex],
        answers: [newValue],
      };
    } else {
      // Add new answer for the blank
      updatedAnswers.push({ indexNo: index, answers: [newValue] });
    }

    setStudentAnswers(updatedAnswers);
    handleBlanks({ indexNo: index, answers: [newValue] }, questionIndex);

    // Adjust input width if needed
    adjustInputWidth(index);

    // Update error state for validation
    setError((prevErrors) => {
      const newErrors = {
        ...prevErrors,
        [index]: newValue.length > 30 ? 'At least one of the blanks is too long.' : '',
      };

      // Count blanks with errors and create dynamic error message
      const errorCount = Object.entries(newErrors).filter(
        ([key, msg]) => key !== 'global' && msg !== ''
      ).length;

      const dynamicMessage =
        errorCount > 0
          ? `At least ${errorCount} ${
              errorCount === 1 ? 'blank is' : 'blanks are'
            } too long. Check your answers before moving on.`
          : '';

      return { ...newErrors, global: dynamicMessage };
    });
  };

  const shuffleArray = (array) => {
    let shuffledArray = [...array];
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
    }
    return shuffledArray;
  };

  useEffect(() => {
    setShuffledBlanksBank(shuffleArray(question.blanksBank));
  }, [question.blanksBank]);

  const hasCorrectAnswers = activity.activityAnswers.some(
    (marks) => marks.totalMarks === marks.givenMarks && marks.isGraded
  );

  const applyTextFormatting = (format) => {
    if (focusedInputIndex === null) return;

    const input = inputRefs.current[focusedInputIndex];
    if (!input) return;

    switch (format) {
      case 'bold':
        input.style.fontWeight = input.style.fontWeight === 'bold' ? 'normal' : 'bold';
        break;
      case 'italic':
        input.style.fontStyle = input.style.fontStyle === 'italic' ? 'normal' : 'italic';
        break;
      case 'underline':
        input.style.textDecoration =
          input.style.textDecoration === 'underline' ? 'none' : 'underline';
        break;
      case 'clear':
        input.style.fontWeight = 'normal';
        input.style.fontStyle = 'normal';
        input.style.textDecoration = 'none';
        break;
      default:
        break;
    }
  };
  const insertCharacter = (char) => {
    if (focusedInputIndex === null) return;

    const input = inputRefs.current[focusedInputIndex];
    if (!input) return;

    // Insert the character at the current cursor position
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const text = input.value;

    input.value = text.slice(0, start) + char + text.slice(end);
    input.selectionStart = input.selectionEnd = start + char.length;

    input.focus();
  };
  const assignedDate = new Date(activity.assignedDate); // Convert to Date object

  const percentageAndDate =
    percentage === 100 &&
    new Date(assignedDate).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0);

  const calculateWidth = (text) => {
    // Create a canvas element
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    // Match input field font size and style
    context.font = '16px Arial'; // Replace 'Arial' with the actual font used in your CSS

    // Measure text width
    const textWidth = context.measureText(text || '').width;

    // Add padding (20px) and set a minimum width of 65px
    return Math.max(65, textWidth + 20);
  };

  return (
    <div className='answer_question_box' key={questionIndex}>
      <h5 className='answer_question_type'>{questionTypes[question.type]}</h5>
      <h4 className='answer_question_title mrb-3'>{question.text}</h4>
      {/* <div style={{ justifyContent: 'center', display: 'flex' }}>
        <div style={{ width: '95%' }}>
          {['text', 'image', 'video', 'audio'].includes(question?.questionInstructionsType) && (
            <MediaComponent
              media={{
                url: question?.questionMediaTypeUrl || '',
                type: question?.questionInstructionsType || 'text',
              }}
              mode='student'
              setMaximizeImage={setMaximizeImage}
              setImageVideoUrl={setImageVideoUrl}
            />
          )}
        </div>
      </div> */}
      {isExpanded && (
        <Fragment>
          {question.type === 'mcqs' || question.type === 'truefalse' ? (
            <OptionStudent
              question={question}
              answers={answers}
              questionIndex={questionIndex}
              setAnswer={setAnswer}
              hasCorrectAnswers={hasCorrectAnswers}
              setSelectedOptionIndex={setSelectedOptionIndex}
              completedActivity={completedActivity}
              activity={activity}
              handleActivityProgress={handleActivityProgress}
              setUpdateAnswers={setUpdateAnswers}
              setMaximizeImage={setMaximizeImage}
              setImageVideoUrl={setImageVideoUrl}
            />
          ) : ['fr', 'mix', 'sa'].includes(question.type) ? (
            <EditorInput
              answers={answers}
              questionIndex={questionIndex}
              editorValue={editorValue}
              setAnswer={setAnswer}
              setAnswerModified={setAnswerModified}
              spanishShow={'true'}
              activity={activity}
              question={question}
              questions={questions}
              hasCorrectAnswers={hasCorrectAnswers}
              completedActivity={completedActivity}
              mode='focused'
              percentageAndDate={percentageAndDate}
            />
          ) : (
            <Fragment>
              <div className='parent_fill-blanks' style={{ background: '#ffff' }}>
                {answers[questionIndex]?.answerText?.map((word, index) => {
                  const blankAnswer =
                    answers?.[questionIndex].studentSelectedBlanks?.find(
                      (e) => e.indexNo === index
                    )?.answers?.[0] || '';

                  // Calculate dynamic width for the input field
                  const widthBlanks = calculateWidth(blankAnswer) + 1; // Pass value to calculateWidth

                  return (
                    <Fragment key={index}>
                      {question?.blanksBank?.findIndex((e) => e?.indexNo === index) > -1 ? (
                        <input
                          className={`blanks-field ${
                            answers[questionIndex]?.answerArray[index]?.trim()
                              ? error[index]
                                ? 'text-long'
                                : 'enter_text'
                              : ''
                          }`}
                          type='text'
                          style={{
                            paddingRight: '8px',
                            width: error[index] ? '80px' : `${widthBlanks}px `,
                            cursor: percentageAndDate ? 'default' : '', // Use "default" instead of "arrow"
                          }}
                          placeholder='blank'
                          ref={(el) => (inputRefs.current[index] = el)}
                          // Get the answer from studentSelectedBanks if it exists

                          // value={
                          //   studentAnswers?.find((e) => e?.indexNo === index)
                          //     ?.answers?.[0] || ""
                          // }
                          value={
                            answers?.[questionIndex].studentSelectedBlanks?.find(
                              (e) => e.indexNo === index
                            )?.answers?.[0] || ''
                          }
                          onChange={(event) => handleInputChange(questionIndex, index, event)}
                          onFocus={() => setFocusedInputIndex(index)}
                          // readOnly={percentageAndDate}
                        />
                      ) : (
                        <span> {word} </span>
                      )}
                    </Fragment>
                  );
                })}
              </div>
              {!percentageAndDate &&
                !completedActivity && ( // Corrected to render when percentage is NOT 100 and date is NOT in the past
                  <>
                    {question?.isStudentBlanksShow && (
                      <Fragment>
                        <div className='answer_question_type mrt-12 mrb-8'>Word bank</div>
                        <div className='blanks-container' style={{ rowGap: '12px' }}>
                          {shuffledBlanksBank?.map((item) => (
                            <div
                              key={item.indexNo}
                              className='parent_input_with_fill fill-blanks-std'
                            >
                              <div className='parent_input'>
                                <textarea
                                  className='orderlist-input alter_words alter_fill-blanks'
                                  style={{
                                    paddingTop: '6px',
                                    paddingBottom: '5px',
                                    cursor: 'default',
                                  }}
                                  rows={1}
                                  value={item.answers.join(', ')}
                                  readOnly
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </Fragment>
                    )}
                  </>
                )}{' '}
              {error.global && <div className='error_fill_in_blanks'>{error.global}</div>}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div className='text-formatting-toolbar'>
                  <img alt='Bold' src={bold} onClick={() => applyTextFormatting('bold')} />
                  <img alt='Italic' src={italic} onClick={() => applyTextFormatting('italic')} />
                  <img
                    alt='Underline'
                    src={underline}
                    onClick={() => applyTextFormatting('underline')}
                  />
                  <img
                    alt='Clear Formatting'
                    src={eraser}
                    onClick={() => applyTextFormatting('clear')}
                  />
                  <img
                    alt='Spanish Characters'
                    src={showSpanishChars ? omegaGray : omega}
                    onClick={() => {
                      if (!completedActivity) {
                        toggleSpanishChars();
                      }
                    }}
                  />
                </div>

                {(percentageAndDate || completedActivity) && (
                  <>
                    {activity?.activityAnswers?.[0].answers?.[questionIndex].givenMarks >=
                    activity?.activityAnswers?.[0].answers?.[questionIndex].totalMarks ? (
                      <div>
                        <span>
                          {question.type === 'mcqs' ||
                          question.type === 'blanks' ||
                          question.type === 'truefalse'
                            ? 'Correct'
                            : activity?.activityAnswers?.[0].answers?.[questionIndex].grade}{' '}
                          <img src={checkMark} alt='Correct' />
                        </span>
                      </div>
                    ) : (
                      <div>
                        <span>
                          {question.type === 'mcqs' ||
                          question.type === 'blanks' ||
                          question.type === 'truefalse'
                            ? 'Incorrect'
                            : activity?.activityAnswers?.[0].answers?.[questionIndex]?.grade}{' '}
                          <img src={crossMark} alt='Incorrect' />
                        </span>
                      </div>
                    )}
                    {/*<div className="saved-correct ">
                    {activity.activityAnswers?.map((answer, index) => (
                      <div key={index}>
                        {answer.answers
                          ?.filter(
                            (ans) =>
                              ans.question._id === questions._id &&
                              ans.type === question.type
                          ) // Filter answers that match the current question ID
                          ?.map((ans, ansIndex) => (
                            <span key={ansIndex}>
                              {ans.isCorrect ? (
                                <>
                                  Correct <img src={checkMark} alt="Correct" />
                                </>
                              ) : (
                                <>
                                  Incorrect{" "}
                                  <img src={crossMark} alt="Incorrect" />
                                </>
                              )}
                            </span>
                          ))}
                      </div>
                    ))}
                  </div>*/}
                  </>
                )}
              </div>
              {showSpanishChars && (
                <div className='spanish-characters'>
                  {'é á í ó ú ü ñ ¿ ¡'.split(' ').map((char, index) => (
                    <span key={index} onClick={() => insertCharacter(char)}>
                      {char}
                    </span>
                  ))}
                </div>
              )}
              {/* Conditionally render the Spanish characters */}
            </Fragment>
          )}
        </Fragment>
      )}

      {(percentageAndDate || completedActivity) &&
        question.type !== 'fr' &&
        question.type !== 'sa' &&
        question.type !== 'blanks' && (
          <div className='saved-correct mr-tp-bt'>
            {activity.activityAnswers?.map((answer, index) => (
              <div key={index}>
                {answer.answers
                  ?.filter(
                    (ans) =>
                      ans.question._id === questions._id && // Ensure it's the correct question ID
                      ans.type === question.type // Ensure the question type matches
                  )
                  ?.slice(0, 1) // Only take the first matching answer to avoid duplication
                  ?.map((ans, ansIndex) => (
                    <span key={ansIndex}>
                      {ans.isCorrect ? (
                        <>
                          Correct <img src={checkMark} alt='Correct' />
                        </>
                      ) : (
                        <>
                          Incorrect <img src={crossMark} alt='Incorrect' />
                        </>
                      )}
                    </span>
                  ))}
              </div>
            ))}
          </div>
        )}
    </div>
  );

  function LastActivityAnswersIndicators({
    activity,
    question,
    questionIndex,
    setAnswer,
    questionTypes,
    answers,
    selectedActivity,
  }) {
    const lastActivityAnswer = activity?.activityAnswers?.[activity?.activityAnswers?.length - 1];

    if (!lastActivityAnswer) {
      return <div>Loading...</div>; // or handle the undefined case appropriately
    }

    return (
      <div className='saved-correct mr-tp-bt'>
        {answers.type === 'mcqs' && answers.type === 'truefalse' && (
          <>
            {lastActivityAnswer &&
              lastActivityAnswer?.answers?.map((answer, index) => (
                <div key={index}>
                  {answer?.isCorrect && answers.answer[questionIndex].answerIndex === index && (
                    <span>
                      Correct <img src={checkMark} alt='' />
                    </span>
                  )}
                  {answer?.isCorrect === false && answers[questionIndex].answerIndex === index && (
                    <span>
                      Incorrect <img src={crossMark} alt='' />
                    </span>
                  )}
                </div>
              ))}
          </>
        )}
      </div>
    );
  }
}

export default StudentAnswer;
